import { DICOM_TAG_NAMES } from 'config/labels';
import styles from './DicomTagModalContent.module.scss';
import Input from '@components/Input';
import { useEffect, useMemo, useState } from 'react';
import { DICOM_TAG_COLUMNS } from 'config/tableColumns';
import { searchItems } from 'utils/searchUtil';
import { useBrowserPage } from '@features/browser/useBrowserPage';
import useAuth from '@hooks/Auth/useAuth';
import { fetchSeriesDicomTags } from '@api/files';
import { DICOM_TAGS } from 'config/dicomTags';
import { defalutModalContentProps } from '@components/Modal/ModalProvider';
import { ICON_MAP } from '@components/Icons/Icons';
import DicomTagTable from '@components/Table/DicomTagTable';

const convertDicomTags = (dicomTags: Record<string, any>) => {
  return Object.entries(dicomTags)
    .filter(([tag]) => DICOM_TAGS[tag])
    .map(([tag, data]) => {
      const tagFormatted = `(${tag.slice(0, 4)},${tag.slice(4)})`;
      const valueArray = data?.Value;
      const value = Array.isArray(valueArray) ? valueArray.join(', ') : '';
      return {
        tag: tagFormatted,
        description: DICOM_TAGS[tag],
        value,
      };
    });
};

const DicomTagModalContent: React.FC<defalutModalContentProps> = ({ close }) => {
  const [searchValue, setsearchValue] = useState<string>("");
  const [dicomData, setDicomData] = useState<any[]>([]);
  const { selectedSeriesId } = useBrowserPage();
  const { accessToken } = useAuth();
  const CloseIcon = ICON_MAP['close'];

  const dummyTagData = [
    { tag: '(0010,0010)', description: 'Patient Name', value: 'John Doe' },
    { tag: '(0010,0020)', description: 'Patient ID', value: '123456' },
    { tag: '(0008,0020)', description: 'Study Date', value: '20250101' },
    { tag: '(0008,0030)', description: 'Study Time', value: '103012' },
    { tag: '(0008,0050)', description: 'Accession Number', value: 'A00123' },
    { tag: '(0010,0030)', description: 'Birth Date', value: '19800101' },
    { tag: '(0010,0040)', description: 'Sex', value: 'M' },
    { tag: '(0020,000D)', description: 'Study Instance UID', value: '1.2.3.4.5.6' },
    { tag: '(0020,000E)', description: 'Series Instance UID', value: '1.2.3.4.5.6.7' },
    { tag: '(0008,0060)', description: 'Modality', value: 'CT' },
  ];

  useEffect(() => {
    if (!accessToken || !selectedSeriesId) return;

    fetchSeriesDicomTags({ accessToken, seriesId: selectedSeriesId })
      .then((res) => {
        const converted = convertDicomTags(res.data);
        if (converted.length > 0) {
          setDicomData(converted);
        } else {
          setDicomData(dummyTagData);
        }
      })
      .catch(() => {
        setDicomData(dummyTagData);
      });
  }, [accessToken, selectedSeriesId]);

  const filteredData = useMemo(() => {
    return searchItems({
      query: searchValue,
      items: dicomData,
    });
  }, [searchValue, dummyTagData]);

  return (
    <div className={styles['tag-modal-container']}>
      <div className={styles['tag-modal-container-1']}>
        <CloseIcon
          className={styles['tag-modal-container-icon']}
          onClick={close}
        />
      </div>
      <div className={styles['tag-modal-container-2']}>
        <div>{DICOM_TAG_NAMES.dicomTagModal}</div>
        <div>
          <Input
            className="defaultSearch"
            type="search"
            value={searchValue}
            onChange={(e: any) => setsearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className={styles['tag-modal-container-3']}>
        <DicomTagTable columns={DICOM_TAG_COLUMNS} data={filteredData} />
      </div>
    </div>
  );
}

export default DicomTagModalContent;
